import React, { Component } from 'react'
import Editor from './Editor'
import { Tooltip } from "@material-ui/core"
import { withStyles } from "@material-ui/core/styles"
import ModelAnnotationContainter from "../ModelAnnotation/ModelAnnotationContainer"
import {checkNotUndefindeNull,replaceSpanWithTextInString} from "../../../../Templates/functions"
import {Markup} from "interweave"
import closingImg from "../../../../../assets/Icons/closeImg.png"
import { SaveStepContentIcon } from "../../../../Templates/icons"

class StepContent extends Component {

    constructor(props) {
        super()
        this.state = {
            saveClick:false
        }
    }

    componentDidUpdate=()=>{
        console.log("step re-rendering")
        
    }

    componentDidMount=()=>{
       //this.updateContentSpan();
         console.log("step rendering")
    }

    saveClicked=()=>{
        this.setState({saveClick:true})
    }

    shouldComponentUpdate=(nextProps, nextState)=>{
        let content =  ""
        let nextContent = ""
        {this.props.selectedStep ? content = this.props.selectedStep.content : content = ""}
        {nextContent.selectedStep ? content = this.props.selectedStep.content : content = ""}
        if (this.props.editingContent && 
            this.props.divStepParent === this.props.selectedStepDivID && 
            content ===  nextContent){
                console.log("component not rerendering")
                return false
            }
            

            console.log("component rerendering")
            return true;
    }

    parseContent =(content) => {
        content = this.addButtons(content)
        //content = this.addAnnotationButtons(content)

        // content = this.addWhiteSpaces(content)
        return content
    }

    addButtons = (content) => {
        if(!checkNotUndefindeNull(content)) return content
        let regExp = /!\[.*?\.*\]/
        let matches = content.match(regExp)
        let totalLength
        if (matches && matches.length) {
            totalLength = matches[0].length
        } else {
            return content
        }
        //finds first instance of regex match and sets starting index as first index
        let firstIndex = content.search(regExp)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceContent(content, firstIndex, totalLength)
        //calls function recursively to continue process with a new string containing a clickable button and updated str
        return this.addButtons(updatedContent)
    }

    addWhiteSpaces = (content) => {
        let regExp = /\x0a/
        let matches = content.match(regExp)
        let totalLength
        if (matches && matches.length) {
            totalLength = matches[0].length
        } else {
            return content
        }
        //finds first instance of regex match and sets starting index as first index
        let firstIndex = content.search(regExp)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceContent(content, firstIndex, totalLength, true)
        //calls function recursively to continue process with a new string containing a clickable button and updated str
        return this.addWhiteSpaces(updatedContent)
    }

    replaceContent = (content, firstIndex, totalLength, blankSpace) => {
        let beginningString = content.substring(0, firstIndex)
        let lastIndex = firstIndex + totalLength
        let removedArea = content.slice(firstIndex + 2, lastIndex - 1)
        let replacedRegexMatch
        let remainingString
        if (!blankSpace) {
            let fileName = removedArea.split("::")[0]
            //The embedded buttons do not have standard onclick event listeners but instead pass value up through propagation.
            //They trigger the event of its parent dom element and which calls on this.props.toggleContentForm.
            //remove +4 in the last index parameter (slice method below) to remove the file extension in button.
            replacedRegexMatch = `<button id="embedded-attachment">${fileName}</button>`
            remainingString = content.substring(lastIndex)
        } else {
            //The embedded buttons do not have standard onclick event listeners but instead pass value up through propagation.
            //They trigger the event of its parent dom element and which calls on this.props.toggleContentForm.
            //remove +4 in the last index parameter (slice method below) to remove the file extension in button.
            replacedRegexMatch = `<br>`
            remainingString = content.substring(lastIndex)
        }
        let updatedContent = beginningString + replacedRegexMatch + remainingString
        return updatedContent
    }

    /////////////////////////////////////////////////////////
    addAnnotationButtons = (content) => {
        let regExp = new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;')
        //let regExpWI = new RegExp('\\&lt;WI,(.*?),(.*?).&gt;')
        let matches = content.match(regExp)
        //let matchesWI = content.match(regExpWI)
        let totalLength
        //let totalLengthWI
        if (matches && matches.length) {
            totalLength = matches[0].length
        }
        else{
            return content
        }
        // if(matchesWI && matchesWI.length){
        //     totalLengthWI = matchesWI[0].length
        // }
        //  if(()) {
        //     return content
        // }
        //finds first instance of regex match and sets starting index as first index
        let firstIndex = content.search(regExp)
        //let firstIndexWI = content.search(regExpWI)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceAnnotationContent(content, firstIndex, totalLength, false ,matches[3])
        //TODO : updatedContent = this.replaceWIContent(content,firstIndexWI,totalLengthWI,false, matches)
        //calls function recursively to continue process with a new string containing a clickable button and updated str
        return this.addAnnotationButtons(updatedContent)
    }

    addAnnotationWhiteSpaces = (content) => {
        let regExp = /\x0a/
        let matches = content.match(regExp)
        let totalLength
        if (matches && matches.length) {
            totalLength = matches[0].length
        } else {
            return content
        }
        //finds first instance of regex match and sets starting index as first index
        let firstIndex = content.search(regExp)
        //replaces content inside of those indices for a clickable button
        let updatedContent = this.replaceContent(content, firstIndex, totalLength, true, {})
        //calls function recursively to continue process with a new string containing a clickable button and updated str
        return this.addAnnotationWhiteSpaces(updatedContent)
    }

    replaceAnnotationContent = (content, firstIndex, totalLength, blankSpace, group) => {
        let beginningString = content.substring(0, firstIndex)
        let lastIndex = firstIndex + totalLength
        let removedArea = content.slice(firstIndex + 2, lastIndex - 1)
        let replacedRegexMatch
        let remainingString 
        if (!blankSpace) {
            let fileName = group//removedArea.split(",")[3]
            //The embedded buttons do not have standard onclick event listeners but instead pass value up through propagation.
            //They trigger the event of its parent dom element and which calls on this.props.toggleContentForm.
            //remove +4 in the last index parameter (slice method below) to remove the file extension in button.
            replacedRegexMatch = `<button id="embedded-annotation">${fileName}</button>`
            remainingString = content.substring(lastIndex)
        } else {
            //The embedded buttons do not have standard onclick event listeners but instead pass value up through propagation.
            //They trigger the event of its parent dom element and which calls on this.props.toggleContentForm.
            //remove +4 in the last index parameter (slice method below) to remove the file extension in button.
            replacedRegexMatch = `<br>`
            remainingString = content.substring(lastIndex)
        }
        let updatedContent = beginningString + replacedRegexMatch + remainingString
        return updatedContent
    }

    conpareWithAnnotations=(content)=>{
        let contentIsThere = false
        console.log(this.props.attachments)
        if(checkNotUndefindeNull(this.props.attachments) && this.props.attachments.length > 0 && checkNotUndefindeNull(this.props.attachments[this.props.attachmentIndex || 0].annotations ))
        {
          let Annotations = this.props.attachments[this.props.attachmentIndex || 0].annotations
          if(checkNotUndefindeNull(Annotations)){
            Annotations.forEach((anno)=>{
                if(content === anno.Anno_id){
                    contentIsThere = true
                }
            })
          }

        }
        return contentIsThere
    }

    removeTags =(content)=>{
        //TODO need to fix
        let con = content
        let newContent = con.replace("<p>", "")
        newContent = newContent.replace("</p>", "")
        let regExp = new RegExp('\\&lt;Annotation,(.*?),(.*?),(.*?).&gt;','g')
        let regExptwo = new RegExp('\\&lt;(Annotation),(.*?),(.*?),(.*?).&gt;')
        let pList = newContent.split(regExptwo)
        let pListTwo = [];
        let matchesAll = [...newContent.matchAll(regExp)]   

        let replacementText = ""
        let newContentSplit = newContent;
        if(null != matchesAll && matchesAll.length > 0){
            for(let i = 0; i < matchesAll.length; i++){
                replacementText = matchesAll[i][3];
                // Always show the text (even if empty) - the X icon will be visible
                const displayText = replacementText;
                
                let closeout = <span style={{zIndex:"100",display:"inline-block",width:"10px",height:"10px"}} ><svg className="clickable"  xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                                    <path  d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5C4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />
                                        </svg></span>
                // 
                let spanText = ''
                if (!this.props.isLiteView){
                    // If text is empty, use non-breaking spaces so the icon appears inline
                    const textPart = displayText.trim() === "" ? "&nbsp;&nbsp;&nbsp;" : displayText;
                    spanText = `<span key="${matchesAll[i][1]}" ` +  
                    `onClick="this.showAnnotationJS(event, ${matchesAll[i][1]})"` +
                    `id="${matchesAll[i][1]}~~~${matchesAll[i][2]}" ` + 
                    `class='clickable AnnotationClickable NCL spansClick'> ` +
                    `${textPart}` +
                    `<img class='closeImgMA' id="close_${matchesAll[i][1]}~~~${matchesAll[i][2]}" src="${closingImg}"/> `+                                                              
                    `</span>`    
                }else{
                    spanText = `<span key="${matchesAll[i][1]}" ` +  
                    `onClick="this.showAnnotationJS(event, ${matchesAll[i][1]})"` +
                    `id="${matchesAll[i][1]}~~~${matchesAll[i][2]}" ` + 
                    `class='clickable AnnotationClickable NCL spansClick'> ` +
                    `${displayText} ` +                                                              
                    `</span>`                        
                }
                
                          
                newContentSplit =  newContentSplit.replace(matchesAll[i][0],spanText)  

            }                      
           newContent = newContentSplit
           newContent = replaceSpanWithTextInString(newContent)
        }
        return newContent;
    }

    removeTagsWI =(content)=>{
        //TODO need to fix
        let con = content
        let newContent = con.replace("<p>", "")
        newContent = newContent.replace("</p>", "")
        let regExp = new RegExp('\\&lt;WI,(.*?),(.*?),(.*?).&gt;','g')
        let regExptwo = new RegExp('\\&lt;(WI),(.*?),(.*?),(.*?).&gt;')
        // let pList = newContent.split(regExptwo)
        // let pListTwo = [];
        let matchesAll = [...newContent.matchAll(regExp)]   
        
        let replacementText = ""
        let newContentSplit = newContent;
    //     let spanX = `<span class='clickable WIClickable WILEB spansClick' style='zIndex:100,display:inline-block,width:10px,height:10px' >`+
    //     `<svg className="clickable"  xmlns="http://www.w3.org/2000/svg" style='display:block' width="15" height="15" viewBox="0 0 15 15" fill="none">` +
    //    `<path  d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />`+
    //    `</svg></span>`  
            let spanX = `<svg className="clickable"  xmlns="http://www.w3.org/2000/svg" style='display:block' width="15" height="15" viewBox="0 0 15 15" fill="none">` + 
                                  `<path  d="M7.5 0C3.3525 0 0 3.3525 0 7.5C0 11.6475 3.3525 15 7.5 15C11.6475 15 15 11.6475 15 7.5C15 3.3525 11.6475 0 7.5 0ZM7.5 13.5C4.1925 13.5 1.5 10.8075 1.5 7.5C1.5 4.1925 4.1925 1.5 7.5 1.5C10.8075 1.5 13.5 4.1925 13.5 7.5C13.5 10.8075 10.8075 13.5 7.5 13.5ZM10.1925 3.75L7.5 6.4425L4.8075 3.75L3.75 4.8075L6.4425 7.5L3.75 10.1925L4.8075 11.25L7.5 8.5575L10.1925 11.25L11.25 10.1925L8.5575 7.5L11.25 4.8075L10.1925 3.75Z" fill="#D7493F" />` +
                                   `</svg>`
                                     
        if(null != matchesAll && matchesAll.length > 0){
            for(let i = 0; i < matchesAll.length; i++){
                   
                    replacementText = matchesAll[i][1];
                    console.log(matchesAll)
                    // 
                    const imgHtml = this.props.isLiteView ? "" : ` <img class='closeImgWI' id="close_${matchesAll[i][2]}" src="${closingImg}"/> `;
                    let displayText = `<span class="wi-link-text">${replacementText}</span>`;
                    let iconHtml = `<span class="wi-link-actions">${imgHtml}</span>`;
                    let spanText = `<span key="${matchesAll[i][2]}" ` +  
                                   `onClick="this.showWI()" ` +
                                   `id="${matchesAll[i][2]}" ` + 
                                   `class='clickable WIClickable WIL spansClick'> ` +
                                   `${displayText}${iconHtml}` +  
                                   `</span>` 
                                                 
                   newContentSplit =  newContentSplit.replace(matchesAll[i][0],spanText)  

            }                      
           newContent = newContentSplit
           newContent = replaceSpanWithTextInString(newContent)
        }
        return newContent;
    }
    ////////////////////////////////////////////////
    renderContent = () => {
       // this.props.closeOutContentEditor()
        let content = this.props.selectedStep ? this.props.selectedStep.content : ""
        let anno = this.props.getSelectedAnnotation();
        content = this.parseContent(content)
        content = this.removeTags(content)
        content = this.removeTagsWI(content)
           
        let contentDiv = (
            // <Tooltip overlay="Click to edit your step content" placement="topLeft">
            // <LightTooltip title="Edit Step Content?" aria-label="Edit Step Content?" placement="top-start">
                <div
                    id="content"
                    className="testclass2"
                    contentEditable={false}
                    >
                     <Markup content={content}/>

                </div>

        )


        return this.props.selectedStep && this.props.selectedStep.content ? 
        // onClick={(e) => this.props.toggleContentForm(e)}
                    <div className={this.props.fromPreview?"clickable max-height": "clickable almostHeight"} >
                        {contentDiv}
                    </div>
            : null
           
    }

    updateContentSpan=()=>{
        let imgs = document.getElementsByClassName("closeImgWI");
        Array.from(imgs).forEach((i)=>{
            console.log(i.id)
            alert(i.id)
            i.addEventListener("click",this.deleteWI)
        })

    }

    updateContent = (content,dontClose,clickedToggle) => {
        let selectedStep = this.props.selectedStep
        if (selectedStep) {
            selectedStep.content = content
            let steps = this.props.updateStep(selectedStep)
            this.props.updateSteps(steps, selectedStep);
            this.props.closeOutContentEditor(clickedToggle)
        }
    }

    addAnnotationObjToStepAttachment=(anno,text)=>{
        let selectedStep = this.props.selectedStep
        let added = false
        if (selectedStep) {
            if(selectedStep.attachments[this.props.attachmentIndex].hasOwnProperty('annotations')){
                let checkForDups = selectedStep.attachments[this.props.attachmentIndex].annotations.filter(a=> a !== anno)
                if (checkForDups.length == 0){
                    selectedStep.attachments[this.props.attachmentIndex].annotations.push(anno)
                    selectedStep.content = text
                    added = true
                }
            }else{
                selectedStep.attachments[this.props.attachmentIndex].annotations = [] 
                selectedStep.content = text
                selectedStep.attachments[this.props.attachmentIndex].annotations.push(anno)
                added = true
            }
            if (added){
                let steps = this.props.updateStep(selectedStep)
                this.props.updateSteps(steps, selectedStep);
                this.props.closeOutContentEditor(false)  
            }

        }
    }

    submitStepNameEdit = (e, stepName) => {
        e.preventDefault()
        let updatedStep = this.props.selectedStep
        updatedStep.title = stepName
        let steps = this.props.updateStep(updatedStep)
        this.props.updateSteps(steps, updatedStep)
        this.props.finishStepTitleEdit()
    }

    showAnnotation=(e)=>{
        alert(e)
       // this.props.clickOnAnnotation(id)
    }

    ModelOrEditorRender = () => {


        if(this.props.toggleAnnotation && this.props.divStepParent === this.props.selectedStepDivID){
         return <ModelAnnotationContainter
         selectedStepIsChild = {this.props.selectedStepIsChild}
         selectedStep={this.props.selectedStep}
         attachmentIndex={this.props.attachmentIndex}
         currentCameraPlacement={this.props.currentCameraPlacement}
         updateContent ={this.updateContent}
         toggleAnnotation ={this.props.toggleAnnotation}
         updateStep={this.props.updateStep}
         updateSteps={this.props.updateSteps}
         unityContextRef = {this.props.unityContextRef}
         removeAnnotationFromScreen={this.props.removeAnnotationFromScreen}
         modelsLoaded = {this.props.modelsLoaded}
         updateSelectedStep={this.props.updateSelectedStep}
         hidden={false}
         /> 
         }                                       
        else {
            if(this.props.editingContent && this.props.divStepParent === this.props.selectedStepDivID){
                return<Editor
                key={Date.now.toString()}
                addAnnotationObjToStepAttachment={this.addAnnotationObjToStepAttachment}
                attachments={this.props.attachments}
                updateContent={this.updateContent}
                content={this.props.selectedStep ? this.props.selectedStep.content : ""}  
                selectedStep = {this.props.selectedStep}
                attachmentIndex={this.props.attachmentIndex}
                fromPreview ={this.props.fromPreview}
                divStepParent={this.props.divStepParent}
                toggleTextSelectedInEditor={this.props.toggleTextSelectedInEditor}
                textSelectedInEditor={this.props.textSelectedInEditor}
                updateEditorRef={this.props.updateEditorRef}
                saveNewAnnotation={this.props.saveNewAnnotation}
                closeOutContentEditor={this.props.closeOutContentEditor}
                annotationHasBeenCreatedPre={this.props.annotationHasBeenCreatedPre}
                textSelectionRange={this.props.textSelectionRange}
                selectedAnnotation={this.props.selectedAnnotation}
                currentStepAttachmentModel={this.props.currentStepAttachmentModel}
                modelsLoaded={this.props.modelsLoaded}
                hidden={false}
                getAttachmentIndex={this.props.getAttachmentIndex}
                getAnnotationHasBeenCreatedPre={this.props.getAnnotationHasBeenCreatedPre}
                getCurrentStepAttachmentModel={this.props.getCurrentStepAttachmentModel}
                getSelectedAnnotation={this.props.getSelectedAnnotation}
                getTextSelectedInEditor={this.props.getTextSelectedInEditor}
                getAddedAnnotation={this.props.getAddedAnnotation}
                addWILink={this.props.addWILink}
                deleteWILink={this.props.deleteWILink}
                saveClicked ={this.state.saveClick}
                isAttachmentModel={this.props.isAttachmentModel}
                />
            }
            else{
                
                return this.renderContent() 
            }  
        }
        
    }

    clickEventHandler=(e)=>{
        // Don't process clicks at all - this handler shouldn't be needed
        // The step div itself handles selection
        return;
    }

    render() {
        let fromPreview = this.props.fromPreview
        return <div id={`${fromPreview ? "preview-step-content-container" :"step-content-container"}`} className={fromPreview ? "max-width overflow": "max-width"}>
            <div id={fromPreview ? "step-actions-step-title-preview" : "step-actions-step-title" }  className ={fromPreview ? "flex-align preview-title" : "flex-align" }> 
                </div>
                <div id="step-content" className={`${!fromPreview ? "stepContentHeight" : "overflow "} paragraph`} style={{ position: !fromPreview ? "relative" : undefined }} >

                {this.ModelOrEditorRender()}
                {!fromPreview && this.props.editingContent && this.props.divStepParent === this.props.selectedStepDivID ? (
                    <div style={{ position: "absolute", right: "16px", bottom: "16px", zIndex: 10 }}
                         onClick={(e) => {
                             e.stopPropagation();
                             e.preventDefault();
                             const btn = document.getElementById("contentEditorSaveButton");
                             if (btn && typeof btn.click === "function") {
                                 btn.click();
                             }
                         }}>
                        {SaveStepContentIcon()}
                    </div>
                ) : null}
                        
                </div>
                {!fromPreview? <div id="stepContentBlueBar" className="leftWhiteBorder" style={{ display:"none" }}></div> : null}
            </div>
    }
}

export default StepContent